module.exports = __webpack_public_path__ + "static/media/Disco Diva.b899049f.jpg";